import { ClassHelper, Label } from "components/lib";
import { useEffect, useState } from "react";
import Style from "./switch_green.module.scss";

export function SwitchGreen(props) {
  // state
  const [on, setOn] = useState(props.default);

  function toggle() {
    setOn(!on);
    props.onChange(props.name, !on, true);
  }

  useEffect(() => {
    setOn(props.value);
  }, [props.value]);

  const trackStyle = ClassHelper(Style, {
    track: true,
    trackOn: on,
    trackOff: !on,
  });

  const handleStyle = ClassHelper(Style, {
    handle: true,
    handleOn: on,
    handleOff: !on,
  });

  return (
    <div className={Style.switch_green}>
      <Label
        text={props.label}
        required={props.required}
        className={Style.label}
      />
      <div className={trackStyle} onClick={toggle}>
        <div className={handleStyle}></div>
      </div>
    </div>
  );
}
